 import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  apps: [],
  mobileLoading: true,
};
 
const appadminSlice = createSlice({
  name: "appadmin",
  initialState,
  reducers: {
    setApp: (state, action) => {
      state.apps = action.payload;
    },
    setUpdateApp: (state, action) => {
      const index = state.apps.findIndex((app) => app.id === action.payload.id);
      if (index !== -1) {
        state.apps[index] = action.payload;
      } else {
        state.apps.push(action.payload);
      }
    },
    deleteApp: (state, action) => {
      const idToDelete = action.payload;
      state.apps = state.apps.filter((app) => app.id !== idToDelete);
    },
    setMobileLoading: (state, action) => {
      state.mobileLoading = action.payload;
    },
  },
});
 
export const { setApp, setUpdateApp, deleteApp, setMobileLoading } =
  appadminSlice.actions;
 
export default appadminSlice.reducer;
